/**
 * @props tabList: list of Tabs.
    * const tabList = [
            {
                title: "Tab Title 1",
                tabBodyComponent: <p>Tabbed Body Component</p>,
                linkTo: "/tab1"
            }, {
            title: "Tab Title 2",
                tabBodyComponent: <p>Tabbed Body Component</p>,
                linkTo: "/tab2"
            },
        ];
 * @props useSeparateUrl: boolean. set this prop to true if you want separate url for each tab.
 * @props parentPath: send parent path in this prop if useSeparateUrl is set to true.
 *       parentPath = {"/componentdirectory"}
 * @props activeTabIndex: Pass index of the tab that you want to keep active when using separate url.
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './TabbedNavigation.styles';
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';

export default function TabbedNavigation({ tabList, useSeparateUrl = false, parentPath, activeTabIndex, onChangeTabCb = () => { }, unMountChildComponentOnSwitch = false }) {

    activeTabIndex = useSeparateUrl ? activeTabIndex : 0;
    const [activeIndex, setActiveIndex] = useState(activeTabIndex);

    useEffect(() => {
        setActiveIndex(activeTabIndex);
    }, [activeTabIndex])

    const handleClick = (index) => {
        onChangeTabCb(index)
        setActiveIndex(index);
    }

    const TabButton = ({ item, idx }) => {
        if (item?.title) {
            return <div style={styles.tabContainer}>
                <Button
                    style={activeIndex !== idx ? styles.tab : {}}
                    onClickCb={() => handleClick(idx)}
                    type={activeIndex === idx ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                >
                    {item.title}
                </Button>
            </div>
        } else {
            return <></>
        }
    }

    return (
        <>
            <div style={styles.tabsContainer}>
                <div style={styles.tabsGroup}>
                    {
                        tabList.map((item, idx) => {
                            return (
                                useSeparateUrl ?
                                    <Link to={`${parentPath}${item.linkTo}`}>
                                        <TabButton item={item} idx={idx} />
                                    </Link>
                                    :
                                    <TabButton item={item} idx={idx} />
                            )
                        })
                    }
                </div>
            </div>
            <div style={styles.panels}>
                {
                    tabList.map((item, idx) => {
                        return unMountChildComponentOnSwitch ? (
                            idx === activeIndex && (
                                <div key={idx} style={{ ...styles.panel, ...(activeIndex === idx ? styles.panelActive : {}) }}>
                                    {item.tabBodyComponent}
                                </div>
                            )
                        ) : (
                            <div key={idx} style={{ ...styles.panel, ...(activeIndex === idx ? styles.panelActive : {}) }}>
                                {item.tabBodyComponent}
                            </div>
                        )
    
                    })
                }
            </div>
        </>
    )
}